// @flow

import * as React from "react"
import {findDOMNode} from "react-dom"
import {connect} from "react-redux"
import Sidebar from "../../components/intake/sidebar"
import ProductList from "../../components/product-list"
import {
  getProductCategories,
  getProductCategory,
  getProduct,
  getProductSet,
  getProductsByCategory,
  getProductsByOptionals,
  getProductsForLater,
} from "../../reducers/products"
import {addProductToBabyList} from "../../actions/baby"
import {toggleProduct, resetToggledProducts} from "../../actions/products"
import type {
  Product,
  ProductSet,
  BabyListOptionalItem,
  Dispatch,
  ProductCategory,
  ProductsByCategory,
  State as ReduxState,
} from "../../types"

type Props = {
  +categories: $ReadOnlyArray<ProductCategory>,
  +products: $ReadOnlyArray<ProductsByCategory>,
  +optionals: $ReadOnlyArray<BabyListOptionalItem>,
  +laters: $ReadOnlyArray<Product | ProductSet>,
  +match: any,
  +dispatch: Dispatch,
}

type State = {
  pidJump: ?string,
  jump: boolean,
  category:
    | ?ProductCategory
    | {id: 0, name: "optionals"}
    | {id: 0, name: "laters"},
}

export class IntakeProductsView extends React.Component<Props, State> {
  handleFuzzySelected: (Product | ProductSet) => void

  constructor(props: Props) {
    super(props)

    const {
      dispatch,
      products,
      match: {
        params: {categoryId},
      },
    } = props

    this.state = {
      category: IntakeProductsView.getCategory(products, categoryId),
      pidJump: null,
      jump: false,
    }

    this.handleFuzzySelected = this.handleFuzzySelected.bind(this)

    dispatch(resetToggledProducts())
  }

  // TODO how can we test this with enzyme?
  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    const {
      products,
      match: {
        params: {categoryId, pid},
      },
    } = nextProps
    const {pidJump} = prevState
    let jump = false
    if (pid && (!pidJump || pid !== pidJump)) {
      jump = true
    }
    // console.log({pid, jump})
    return {
      category: IntakeProductsView.getCategory(products, categoryId),
      pidJump: pid,
      jump,
    }
  }

  static getCategory(
    products: $ReadOnlyArray<ProductsByCategory>,
    categoryId: string
  ) {
    switch (categoryId) {
      case "optionals":
        return {id: 0, name: "optionals"}
      case "laters":
        return {id: 0, name: "laters"}
      default:
        return getProductCategory(products, parseInt(categoryId))
    }
  }

  componentDidMount() {
    this.handleJump()
  }

  componentDidUpdate() {
    this.handleJump()
  }

  handleJump() {
    const {pidJump, jump} = this.state
    if (pidJump && jump) {
      this.setState({jump: false}, () => {
        this.jumpToProduct(pidJump)
      })
    }
  }

  jumpToProduct(pid: string) {
    const el = findDOMNode(document.querySelector(`.product-list-item.${pid}`))
    if (!el) {
      return
    }
    // Scroll
    this.scrollTo(el)
    // Toggle
    const {dispatch, products} = this.props
    let product = null
    let [type, id] = pid.split(/(ps|p){1}([0-9]{1,2})/, 3).slice(1)
    if (type === "ps") {
      product = getProductSet(parseInt(id), products)
    } else {
      product = getProduct(parseInt(id), products)
    }
    setTimeout(() => {
      if (product) {
        dispatch(toggleProduct(product))
      }
    }, 400)
  }

  scrollTo(el: any) {
    const doc = document.documentElement
    if (!doc || !el) {
      return
    }
    const windowTop =
      (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    const {top: holderTop, height: holderHeight} = el.getBoundingClientRect()
    const holderSum = holderTop + windowTop + holderHeight
    window.scrollTo(0, windowTop + holderSum)
  }

  getProductsToRender() {
    const {
      laters,
      products,
      optionals,
      match: {
        params: {categoryId},
      },
    } = this.props
    const {category} = this.state
    if (!category) {
      return []
    }
    switch (categoryId) {
      case "optionals":
        return getProductsByOptionals(products, optionals)
      case "laters":
        return laters
      default:
        return getProductsByCategory(products, category.id)
    }
  }

  handleFuzzySelected(item: Product | ProductSet) {
    const {
      dispatch,
      match: {
        params: {babyToken},
      },
    } = this.props
    dispatch(addProductToBabyList(babyToken, item))
  }

  renderCategoryName() {
    const {category} = this.state
    if (!category) {
      return ""
    }
    switch (category.name) {
      case "optionals":
        return "optionals"
      case "laters":
        return "laters"
      default:
        return category.name
    }
  }

  render() {
    const {
      categories,
      optionals,
      laters,
      match: {
        params: {babyToken},
      },
    } = this.props
    const {category} = this.state
    if (!category) {
      return null
    }
    const productsByCategory = this.getProductsToRender()
    return (
      <div className="intake-view-container">
        <Sidebar
          categories={categories}
          optionals={optionals}
          laters={laters}
        />
        <div className="intake-view-main">
          <h2>{this.renderCategoryName()}</h2>
          <ProductList
            products={productsByCategory}
            optionals={optionals}
            babyToken={babyToken}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState): any => ({
  categories: getProductCategories(state),
  products: state.products.entities.products,
  optionals: state.baby.optionals,
  laters: getProductsForLater(state.products.entities.products),
})

export default connect(mapStateToProps)(IntakeProductsView)
